import React from 'react';

interface CardProps {
  title?: string;
  children: React.ReactNode;
  centered?: boolean;
}

export const Card: React.FC<CardProps> = ({ title, children, centered }) => (
  <div className={`bg-zinc-800 rounded-2xl p-6 border border-zinc-700 ${centered ? 'text-center' : ''}`}>
    {title && <h2 className="text-2xl font-bold text-white mb-6">{title}</h2>}
    {children}
  </div>
);
